import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
	RxIntuitiveImplantPositionModalComponent,
	RxIntuitiveImplantPositionModalData,
	RxIntuitiveImplantPositionModalResult
} from './rx-intuitive-implant-position-modal.component';
import { IntuitiveToothForDiagram } from '../../models/intuitive-tooth-for-diagram';
import { ToothModalOpenOptions, ToothModalService } from '../../models/tooth-modal';
import { Tooth } from '@modules/teeth-diagram/models/tooth';

@Injectable({ providedIn: 'root' })
export class ImplantPositionModalService implements ToothModalService {
	constructor(private readonly modalService: TlkModalWindowService) {}

	/**
	 * Opens ImplantPosition modal for the given teeth.
	 * @param teeth - Mapped teeth view models to display
	 * @param initialTooth - Initial tooth data (to extract ImplantTypeID)
	 * @param options
	 * @returns Observable that emits partial Tooth updates or null if cancelled
	 */
	open(
		teeth: IntuitiveToothForDiagram[],
		initialTooth: Tooth,
		options?: ToothModalOpenOptions
	): Observable<RxIntuitiveImplantPositionModalResult> {
		void options;

		const modalData: RxIntuitiveImplantPositionModalData = {
			teeth,
			implantTypeId: initialTooth?.ImplantTypeID ?? null
		};

		const dialogRef = this.modalService.open(RxIntuitiveImplantPositionModalComponent, {
			panelClass: 'rx-intuitive-implant-position-modal-dialog',
			data: modalData,
			autoFocus: true,
			disableClose: true
		});

		return dialogRef.closed.pipe(map((result: RxIntuitiveImplantPositionModalResult) => result));
	}
}
